import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BehaviorsModule } from '@ddv/behaviors';
import { CommonComponentsModule } from '@ddv/common-components';
import { DatasetsModule, SlowDataApprovalComponent } from '@ddv/datasets';
import { EntitlementsModule } from '@ddv/entitlements';
import { ReferenceDataModule } from '@ddv/reference-data';
import { LibSvgIconsModule } from '@ddv/svg-icons';
import { VisualizationsModule } from '@ddv/visualizations';
import { WidgetDragTargetDirective, WidgetOnBoardComponent, WidgetOnBoardsModule } from '@ddv/widget-on-boards';
import { WidgetsModule } from '@ddv/widgets';
import { OperatorPickerComponent } from '@hs/ui-core-additional-filters';
import { SingleSelectDropdownComponent } from '@hs/ui-core-dropdowns';
import { OptionToggleComponent } from '@hs/ui-core-inputs';
import { ListComponent } from '@hs/ui-core-lists';
import { IconComponent } from '@hs/ui-core-presentation';

import { ClearFiltersIconComponent } from './components/clear-filters-icon/clear-filters-icon.component';
import { DashBoardComponent } from './components/dashboard/dashboard.component';
import { SaveDashboardFormComponent } from './components/save-dashboard-form/save-dashboard-form.component';
import { VersionsService } from './components/user-preference/versions.service';
import { WorkspaceSizerService } from './components/workspace/workspace-sizer.service';
import { WorkspaceComponent } from './components/workspace/workspace.component';
import { AdditionalFiltersService } from './services/additional-filters.service';
import { DashboardExportService } from './services/dashboard-export.service';
import { DashboardFiltersService } from './services/dashboard-filters.service';
import { DashboardGroupsService } from './services/dashboard-groups.service';
import { DashboardNotesService } from './services/dashboard-notes.service';
import { DashboardPDFExportService } from './services/dashboard-pdf-export';
import { DashboardSharingService } from './services/dashboard-sharing.service';
import { DashboardService } from './services/dashboard.service';
import { PDFExportService } from './services/pdf-export.service';
import { WidgetQueryparamService } from './services/widget-queryparam.service';

@NgModule({
    imports: [
        BehaviorsModule,
        CommonComponentsModule,
        CommonModule,
        DatasetsModule,
        EntitlementsModule,
        FormsModule,
        IconComponent,
        LibSvgIconsModule,
        ListComponent,
        OperatorPickerComponent,
        OptionToggleComponent,
        ReactiveFormsModule,
        ReferenceDataModule,
        RouterModule,
        SingleSelectDropdownComponent,
        VisualizationsModule,
        WidgetsModule,
        WidgetOnBoardsModule,
        WidgetOnBoardComponent,
        WidgetDragTargetDirective,
        SlowDataApprovalComponent,
    ],
    providers: [
        AdditionalFiltersService,
        DashboardService,
        DashboardExportService,
        DashboardFiltersService,
        DashboardGroupsService,
        DashboardNotesService,
        DashboardPDFExportService,
        DashboardSharingService,
        PDFExportService,
        VersionsService,
        WidgetQueryparamService,
        WorkspaceSizerService,
    ],
    declarations: [
        ClearFiltersIconComponent,
        DashBoardComponent,
        SaveDashboardFormComponent,
        WorkspaceComponent,
    ],
    exports: [
        DashBoardComponent,
        SaveDashboardFormComponent,
        WorkspaceComponent,
    ],
})
export class DashboardsModule {}
